import {
  SET_NEWSLETTER_NOTIFICATIONS,
  UPDATE_NEWSLETTER_NOTIFICATION,
  UPDATE_NEWSLETTER_NOTIFICATION_ERROR,
  RESTORE_NEWSLETTER_NOTIFICATIONS,
  DISABLE_NEWSLETTER_NOTIFICATION_FROM_EMAIL,
} from './actionTypes';
import initialState from './initialState';

function updateChanged(prevNotifications, [key, notification]) {
  const foundNotification = prevNotifications[key];
  if (!foundNotification) {
    return {
      ...prevNotifications,
      [key]: {
        ...notification,
        changed: false,
      },
    };
  }

  return {
    ...prevNotifications,
    [key]: {
      ...notification,
      changed: foundNotification.active !== notification.active,
    },
  };
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_NEWSLETTER_NOTIFICATIONS:
      return Object.entries(payload).reduce(
        (accumulator, notification) => updateChanged(accumulator, notification),
        state
      );
    case UPDATE_NEWSLETTER_NOTIFICATION: {
      return {
        ...state,
        [payload.type]: {
          active: payload.active,
          changed: state[payload.type].active !== payload.active,
        },
      };
    }
    case UPDATE_NEWSLETTER_NOTIFICATION_ERROR:
      return {
        ...state,
        [payload.type]: {
          active: payload.active,
          changed: false,
        },
      };
    case RESTORE_NEWSLETTER_NOTIFICATIONS:
      return Object.entries(payload).reduce(
        (acc, [key, notification]) => ({ ...acc, [key]: { ...notification, changed: false } }),
        {}
      );
    case DISABLE_NEWSLETTER_NOTIFICATION_FROM_EMAIL: {
      return {
        ...state,
        [payload]: {
          active: false,
          changed: true,
        },
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/NewsletterNotifications/reducer.js